import { logger } from '@origin-digital/reporting-client';
import { LoginError } from '../../login/interfaces';
import { getDeviceId } from '../../url/UrlUtils';

const handleIFrameLoginError = (errorCode: string, usernameOrState: string): LoginError => {
  logErrors(errorCode, usernameOrState);

  if (errorCode === 'invalid_user_password') {
    return {
      passwordError: true,
    };
  }

  return {
    navigateToErrorPage: true,
  };
};

const logErrors = (errorCode: string, usernameOrState: string) => {
  // too much noise in logs for invalid user password
  if (errorCode !== 'invalid_user_password') {
    const deviceId = getDeviceId();
    logger.error(
      `handleError invoked ${usernameOrState} with errorCode: ${errorCode}, uniqueId: ${deviceId}`,
      new Error(`${usernameOrState}: errorCode: ${errorCode}, uniqueId: ${deviceId}`),
    );
  }
};

export { handleIFrameLoginError };
